import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { Config } from '@shared/config';
import { StorageService } from '@shared/services/storage.service';

@Pipe({
    name: 'dateRange'
})
export class DateRangePipe implements PipeTransform
{
    constructor(public storage: StorageService) {
    }

    transform(startDateStr: any, endDateStr: any): any {
        if (endDateStr != null) {
            const startDate = moment(startDateStr, Config.DATE_FORMAT_BACKEND, this.storage.getLang());
            const endDate = moment(endDateStr, Config.DATE_FORMAT_BACKEND, this.storage.getLang())

            if (startDate.isSame(endDate, 'day')) {
                return [
                    startDate.format(Config.DATE_FORMAT_FRONTEND_TIME_ONLY),
                    endDate.format(Config.DATE_FORMAT_FRONTEND_TIME_ONLY)
                ].join(' - ');
            } else { // start & end of event are on different days
                return [
                    startDate.format(Config.DATE_FORMAT_FRONTEND_FULL),
                    endDate.format(Config.DATE_FORMAT_FRONTEND_FULL)
                ].join(' - ');
            }
        } else { // Only start date provided
            return moment(startDateStr, Config.DATE_FORMAT_BACKEND, this.storage.getLang())
                .format(Config.DATE_FORMAT_FRONTEND_TIME_ONLY)
        }
    }
}
